import { useAppSelector, useAppDispatch } from 'hooks';

import { Text, SimpleGrid } from '@chakra-ui/react';

import Card from 'components/card/Card';

import FormInput from 'components/fields/home/FormInput';

import { changeApplicantInformation } from 'reducers/homePersonalFormReducer';

import { SECTIONS } from 'views/home_form/constants';

const ApplicantInformation = () => {
  const dispatch = useAppDispatch();

  const data = useAppSelector(
    (state) => state.homePersonalForm.data.applicant_information,
  );

  const onApplicantInformationChange = (event: any) => {
    const { name, value, checked, type } = event.target;
    const payload = type === 'checkbox' ? checked : value;

    dispatch(changeApplicantInformation({ name, value: payload }));
  };

  if (!data) return null;

  return (
    <Card mb="20px" id="sectionApplicantInformation">
      <Text fontWeight="bold" fontSize="2xl" mb="20px">
        Applicant Information
      </Text>

      <SimpleGrid columns={4} spacing="20px">
        <FormInput
          section={SECTIONS.APPLICANT_INFORMATION}
          label="Address"
          name="address"
          value={data.address || ''}
          onChange={onApplicantInformationChange}
          disabled
        />
        <FormInput
          section={SECTIONS.APPLICANT_INFORMATION}
          label="City"
          name="city"
          value={data.city || ''}
          onChange={onApplicantInformationChange}
          disabled
        />
        <FormInput
          section={SECTIONS.APPLICANT_INFORMATION}
          label="Province"
          name="province_code"
          value={data.province_code || ''}
          onChange={onApplicantInformationChange}
          disabled
        />
        <FormInput
          section={SECTIONS.APPLICANT_INFORMATION}
          label="Postal Code"
          name="postal_code"
          value={data.postal_code || ''}
          onChange={onApplicantInformationChange}
          disabled
        />
        <FormInput
          section={SECTIONS.APPLICANT_INFORMATION}
          label="Home Phone"
          name="phone_home"
          value={data.phone_home || ''}
          onChange={onApplicantInformationChange}
        />
        <FormInput
          section={SECTIONS.APPLICANT_INFORMATION}
          label="Cell Phone"
          name="phone_cell"
          value={data.phone_cell || ''}
          onChange={onApplicantInformationChange}
        />
        <FormInput
          section={SECTIONS.APPLICANT_INFORMATION}
          label="Business Phone"
          name="phone_business"
          value={data.phone_business || ''}
          onChange={onApplicantInformationChange}
        />
        <FormInput
          section={SECTIONS.APPLICANT_INFORMATION}
          label="Website"
          name="website"
          value={data.website || ''}
          onChange={onApplicantInformationChange}
        />
      </SimpleGrid>
    </Card>
  );
};

export default ApplicantInformation;
